import OrderTypeEnum from '@/api/Enums/OrderTypeEnum.js'
import KdsOrderStatusEnum from '@/api/Enums/KdsOrderStatusEnum.js'
import KdsOrderItemStatusEnum from '@/api/Enums/KdsOrderItemStatusEnum.js'

export default {
  Title: 'KDS',

  List: {
    NoData: {
      Icon            : 'mdi-basket-off-outline',
      IconColor       : 'light-blue',
      Title           : 'Δεν υπάρχουν παραγγελίες',
      TitleOpen       : 'Δεν υπάρχουν ανοιχτές παραγγελίες {source}',
      TitleOnHold     : 'Δεν υπάρχουν παραγγελίες {source} σε αναμονή',
      TitleCompleted  : 'Δεν υπάρχουν ολοκληρωμένες παραγγελίες {source}',
      TitleCanceled   : 'Δεν υπάρχουν ακυρωμένες παραγγελίες {source}',
      SourceTable     : 'τραπεζιού',
      SourceDelivery  : 'παράδοσης',
      SourceCollection: 'παραλαβής',
      Subtitle        : ''
    }
  },

  Dialog: {
    Actions: {
      Toolbar: {
        Title   : '',
        Subtitle: '',
        Icon    : 'mdi-history'
      }
    }
  },

  OrderType: {
    All: {
      Id   : OrderTypeEnum.ALL,
      Code : '0',
      Name : 'Όλες',
      Color: ''
    },
    Table: {
      Id   : -1,
      Code : '-1',
      Name : 'Τραπέζι',
      Color: 'brown'
    },
    Collection: {
      Id   : OrderTypeEnum.COLLECTION,
      Code : '2',
      Name : '@:Order.Type.Item.Collection.Title',
      Icon : '@:Order.Type.Item.Collection.Icon',
      Color: '@:Order.Type.Item.Collection.Color'
    },
    Delivery: {
      Id   : OrderTypeEnum.DELIVERY,
      Code : '1',
      Name : '@:Order.Type.Item.Delivery.Title',
      Icon : '@:Order.Type.Item.Delivery.Icon',
      Color: '@:Order.Type.Item.Delivery.Color'
    }
  },

  Action: {
    Order: {
      Complete: {
        Name : 'Ολοκλήρωση',
        Color: 'green',
        Icon : 'mdi-check'
      },
      Hold: {
        Name : 'Αναμονή',
        Color: 'grey darken-1',
        Icon : 'mdi-timer-pause-outline'
      },
      Resume: {
        Name : 'Έναρξη',
        Color: 'blue',
        Icon : 'mdi-timer-play-outline'
      },
      Revert: {
        Name : 'Επαναφορά',
        Color: 'orange',
        Icon : 'mdi-undo'
      },
      Cancel: {
        Name : 'Ακύρωση',
        Color: 'red',
        Icon : 'mdi-close'
      },
      Forward: {
        Name : 'Μπροστά',
        Color: 'blue-grey',
        Icon : 'mdi-rewind-outline'
      },
      Backward: {
        Name : 'Πίσω',
        Color: 'blue-grey',
        Icon : 'mdi-fast-forward-outline'
      },
      First: {
        Name : 'Πρώτη',
        Color: 'cyan',
        Icon : 'mdi-skip-backward'
      },
      Last: {
        Name : 'Τελευταία',
        Color: 'cyan',
        Icon : 'mdi-skip-forward'
      }
    },

    Item: {
      Complete: {
        Name : 'Ολοκλήρωση',
        Color: 'green',
        Icon : 'mdi-check'
      },
      Hold: {
        Name : 'Αναμονή',
        Color: 'grey darken-1',
        Icon : 'mdi-pause'
      },
      Revert: {
        Name : 'Επαναφορά',
        Color: 'orange',
        Icon : 'mdi-undo'
      },
      Start: {
        Name : 'Έναρξη',
        Color: 'blue',
        Icon : 'mdi-play'
      },
      Cancel: {
        Name : 'Ακύρωση',
        Color: 'red',
        Icon : 'mdi-close'
      }
    }
  },

  Status: {
    Order: {
      Open: {
        Id   : 1,
        Code : KdsOrderStatusEnum.OPEN,
        Name : 'Ανοιχτές',
        Color: 'blue',
        Icon : 'mdi-arrow-right-bold'
      },

      Hold: {
        Id   : 2,
        Code : KdsOrderStatusEnum.HOLD,
        Name : 'Σε Αναμονή',
        Color: 'grey',
        Icon : 'mdi-pause'
      },

      Complete: {
        Id   : 3,
        Code : KdsOrderStatusEnum.COMPLETE,
        Name : 'Ολοκληρωμένες',
        Color: 'green',
        Icon : 'mdi-check'
      },

      Cancel: {
        Id   : 4,
        Code : KdsOrderStatusEnum.CANCEL,
        Name : 'Ακυρωμένες',
        Color: 'red',
        Icon : 'mdi-close'
      }
    },

    Item: {
      Open: {
        Id   : 1,
        Code : KdsOrderItemStatusEnum.OPEN,
        Name : 'Ανοιχτό',
        Color: 'blue',
        Icon : 'mdi-arrow-right-bold'
      },

      Start: {
        Id   : 2,
        Code : KdsOrderItemStatusEnum.START,
        Name : 'Ξεκίνησε',
        Color: 'blue',
        Icon : 'mdi-play'
      },

      Hold: {
        Id   : 3,
        Code : KdsOrderItemStatusEnum.HOLD,
        Name : 'Σε Αναμονή',
        Color: 'grey',
        Icon : 'mdi-pause'
      },

      Complete: {
        Id   : 4,
        Code : KdsOrderItemStatusEnum.COMPLETE,
        Name : 'Ολοκληρωμένο',
        Color: 'green',
        Icon : 'mdi-check'
      },

      Cancel: {
        Id   : 5,
        Code : KdsOrderItemStatusEnum.CANCEL,
        Name : 'Ακυρωμένο',
        Color: 'red',
        Icon : 'mdi-close'
      }
    }
  }
}
